import fetch from 'isomorphic-fetch';

export default fetch;



// WEBPACK FOOTER //
// ./src/@utils/fetch/index.web.js